import {
  FETCH_INVOICES,
  PUSH_INVOICES,
  UPDATE_INVOICES,
  REMOVE_INVOICES,
 } from '../actions/invoicesActions';

const INITIAL_STATE = {
  data: [],
}

export default function invoicesReducer(state = INITIAL_STATE, action){
  switch(action.type){
    case FETCH_INVOICES:
      return {
        ...state,
        data:action.data,
      }
    case PUSH_INVOICES:
      return {
        ...state,
        data:[action.data, ...state.data],
      }
    case UPDATE_INVOICES:
      let updated = state.data.map((v)=>{
        if(v._id === action.data._id) {
          return action.data
        } else return v
      })
      return {
        ...state,
        data: updated
      }
    case REMOVE_INVOICES:
      return {
        ...state,
        data: [...state.data.filter( (item) => item._id !== action.data._id)]
      }
    default:
      return state

  }
}